module.exports = __webpack_public_path__ + "img/resume-parser.a768193e.svg";